import React from 'react';
import PropTypes from 'prop-types';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  useAuthenticationFactorListContext,
} from 'Components/ComponentLibrary/Organisms/AuthenticationFactorList/AuthenticationFactorListContext';
import { FDPrimaryActionButton } from '@facet-wealth/design';


const AuthenticationFactorModalActionDefault = ({ authenticationFactorResource }) => {
  const authenticationType = authenticationFactorResource.selectedOptionPrompt('authenticationType');
  const { clearModalLink } = useAuthenticationFactorListContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <FDPrimaryActionButton
      onClick={() => {
        logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, `Auth Factor ${authenticationType}: Dismiss success`);
        clearModalLink();
      }}
      test={'security-settings-button-authentication-factor-success-close'}
      label={'Continue'}
    />
  );
};

AuthenticationFactorModalActionDefault.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default AuthenticationFactorModalActionDefault;
